"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab2 = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
// export function Tab2(){
//   return (
//     <div className="tab2">
//       <ul>
//         <li>上证指数</li>
//         <li>上证指数</li>
//         <li>上证指数</li>
//       </ul>
//     </div>
//   )
// }
var overcd;
/**
 * 行情tab框
 * @param props
 * @returns
 */
function Tab2(props) {
    var _a;
    var mt = 0;
    if (props.mt != undefined) {
        mt = props.mt;
    }
    var noborder = (_a = props.noborder) !== null && _a !== void 0 ? _a : false;
    /** 当前显示index */
    var _b = (0, react_1.useState)(0), nowindex = _b[0], SetNowIndex = _b[1];
    (0, react_1.useEffect)(function () {
        props.defaultindex != undefined && SetNowIndex(props.defaultindex);
    }, [props.defaultindex]);
    var mouseover = function (index) {
        if (props.boxdata[index].faketab == true) {
            return false;
        }
        overcd = setTimeout(function () {
            SetNowIndex(index);
        }, 200);
        props.changeTabCallback && props.changeTabCallback(index);
    };
    var mouseout = function () {
        clearTimeout(overcd);
    };
    if (props.boxdata.length == 0)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var liclass = '';
    var ulclass = '';
    if (props.tab_fill == 'split') { //均分
        liclass = 'df' + props.boxdata.length.toString();
    }
    else if (props.tab_fill == 'full') { //填满
        ulclass = 'full';
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "tab2", style: { marginTop: mt } },
            react_1.default.createElement("div", { className: "tab2_t scf" },
                //多个tab变成ul li
                props.boxdata.length > 0 &&
                    react_1.default.createElement("ul", { className: ulclass }, props.boxdata.map(function (v, index) {
                        return react_1.default.createElement("li", { key: index, onMouseOver: function (e) { mouseover(index); }, onMouseOut: mouseout, className: liclass + ' ' + (index == nowindex ? 'active' : '') }, v.tab_html);
                    })),
                props.boxdata[nowindex].more != undefined &&
                    react_1.default.createElement("div", { className: "tab2_t_more" }, props.boxdata[nowindex].more)),
            react_1.default.createElement("div", { className: "tab2_c ".concat(noborder ? 'sidertabbox_c_noborder' : '') }, props.children)),
        props.boxdata[nowindex].body,
        props.boxdata[nowindex].bottom && props.boxdata[nowindex].bottom));
}
exports.Tab2 = Tab2;
